export default {
    permissions: {}
  }
  